import { useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { sendDownloadLink } from "../../../core/api/objects/objects";
import { notify } from "../../../ui-lib/components/Alerts/Toast";
import { getErrorKey } from "../../../components/Errors/ErrorAlert";

import useUser from "../../../core/user/useUser";
import useTranslations from "../../../core/i18n/useTranslations";
import PrimeModal from "../../../ui-lib/components/PrimeModal/PrimeModal";

const DownloadLinkModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const t = useTranslations();
  const { id } = useParams<{ id: string }>();
  const { authenticatedRequest } = useUser();

  const onSubmit = async () => {
    try {
      await sendDownloadLink(id, authenticatedRequest);
      notify({
        message: t("Messages:download_link_send_success"),
      });
      onClose();
    } catch (error) {
      const errorKey = getErrorKey(error);
      notify({
        message: t(`Errors:${errorKey}`),
        variant: "error",
      });
    }
  };

  return (
    <PrimeModal
      withHeader
      withFooter
      header={t("Objects:download_link_send")}
      isOpen={isOpen}
      onClose={onClose}
      fixedWidth="576px"
      submitBtn={{
        text: t("Objects:download_link_send_short"),
        onClick: onSubmit,
      }}
      cancelBtn={{ text: t("Common:cancel"), onClick: onClose }}
    >
      <p style={{ color: "var(--Grey-600)" }}>
        {t("Messages:download_link_send")}
      </p>
    </PrimeModal>
  );
};

export default observer(DownloadLinkModal);
